const config = {
  API_URL: process.env.REACT_APP_API_URL || (window.location.protocol + '//' + window.location.host),
  API_BASE_URL: process.env.REACT_APP_API_URL || (window.location.protocol + '//' + window.location.host),
  // Unpredictable SPA path for admin login (build-time). Do not publish.
  ADMIN_PANEL_PATH: process.env.REACT_APP_ADMIN_PANEL_PATH || '/atx-panel'
};

export default config;
